import React from 'react';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import Tooltip from '@mui/material/Tooltip';

import css from './UserBadge.module.css';

const UserBadge = ({ accreditationApproved }) => {
  const badges = [];

  if (accreditationApproved) {
    badges.push(
      <Tooltip key="verified" title="Verified User" arrow>
        <span className={`${css.badge} ${css.verified}`}>
          <VerifiedUserIcon fontSize="small" />
        </span>
      </Tooltip>
    );
  }

  return <div className={css.userBadges}>{badges}</div>;
};

export default UserBadge;
